module.exports = __webpack_public_path__ + "img/Isle-of-Man.7e601ed8.png";